var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M10.9 0.0996094C4.89999 0.0996094 0 4.99961 0 10.9996C0 14.0996 1.30001 16.9996 3.60001 19.0996C5.00001 16.3996 7.79999 14.5996 10.9 14.5996C8.39999 14.5996 6.39999 12.5996 6.39999 10.0996C6.39999 7.59961 8.39999 5.59961 10.9 5.59961C13.4 5.59961 15.4 7.59961 15.4 10.0996C15.4 12.5996 13.4 14.5996 10.9 14.5996C14 14.5996 16.8 16.2996 18.2 19.0996C22.7 15.0996 23 8.19961 19 3.79961C17 1.39961 14 0.0996094 10.9 0.0996094Z",
    fill: "#7FBB51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 14.5996C13.3857 14.5996 15.4004 12.5849 15.4004 10.0996C15.4004 7.61433 13.3857 5.59961 10.9004 5.59961C8.41511 5.59961 6.40039 7.61433 6.40039 10.0996C6.40039 12.5849 8.41511 14.5996 10.9004 14.5996Z",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7002 19.0001C5.7002 15.0001 10.6002 13.4001 14.7002 15.4001C16.2002 16.2001 17.5002 17.4001 18.3002 19.0001",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/edit-user.2e15dcd6091210fe1720d3e029659c46.svg";
export { ForwardRef as ReactComponent };